import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SignalEventType } from 'src/app/shared/models/SignalModel';
import { SignalRService } from 'src/app/shared/services/signal-rservice.service';
import { NotificationsService } from 'src/app/shared/services/notifications.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { User } from 'src/app/shared/models/auth';
import { Notification, NotificationsModel, NotificationType } from 'src/app/shared/models/Notification';
import { ToolCodeEnum } from 'src/app/shared/models/global/enums/toolCodeEnum';
import { MyReleasesList } from 'src/app/features/central-apps-hub/modules/applications/models/Azure.models';
import { AzureService } from 'src/app/features/central-apps-hub/modules/applications/services/Azure.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() sidebarTrigger = new EventEmitter();
  currentUser: User | null = new User();
  collapse: boolean = false
  subscriptions: Subscription[] = [];
  toolCodeEnum = ToolCodeEnum;

  releasesLoading = false;
  releasesList: MyReleasesList[] = [];

  // Notifications
  pageNumber = 1;
  pageSize = 10;
  pageCount: number = 0;
  notificationsResult: any = {
    unSeenNotificationsCount: 0,
    totalCount: 0,
  };
  notifLoading = false;
  notificationsList: Notification[] = [];
  NotificationsModel = new NotificationsModel();
  notificationType = NotificationType;

  constructor(
    private router: Router,
    private readonly translate: TranslateService,
    public dialogRef: MatDialog,
    private authenticationService: AuthenticationService,
    private notificationsService: NotificationsService,
    private azureService: AzureService,
    private signal: SignalRService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getNotifications();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.changeNotificationCount)
        .subscribe(message => {
          this.changeNotificationCount(message.data);
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  changeNotificationCount(data: any) {
    this.getNotifications();
  }

  // Actions
  changeLanguage() {
    if (localStorage.getItem('language') === 'en') {
      localStorage.setItem('language', 'ar');
    } else {
      localStorage.setItem('language', 'en');
    }
    window.location.reload();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  // Notifications
  seeNotifications(notif: Notification) {
    this.notificationsService.SeeNotifications(notif.notificationId).subscribe(
      (result) => {
        // this.notificationsResult.unSeenNotificationsCount = result;
        this.getNotifications(true)
      }, err => {
        console.error(err);
      });
  }

  openReleasesPanel() {
    this.MyReleases();
  }
  MyReleases() {
    this.releasesLoading = true;
    this.azureService.MyReleases().subscribe(
      (result: MyReleasesList[]) => {
        this.releasesLoading = false;
        this.releasesList = result;
      }, (err: any) => {
        this.notifLoading = false;
        console.error(err);
      });
  }

  /*************************************************/

  openNotificationPanel() {
    if (!this.notificationsList.length) {
      this.getNotifications();
    }
  }

  getNextPage() {
    if (this.pageNumber < this.pageCount) {
      this.pageNumber += 1;
      this.getNotifications(false, true);
    }
  }
  getNotifications(update = true, isScroll = false) {
    if (update) {
      this.pageNumber = 1;
      this.notificationsList = [];
    }
    this.notifLoading = !isScroll;
    this.NotificationsModel.pageSize = this.pageSize;
    this.NotificationsModel.pageNumber = this.pageNumber;
    this.notificationsService.GetNotifications(this.NotificationsModel).subscribe(
      result => {
        this.notifLoading = false;
        this.notificationsResult = result;
        this.pageCount = Math.ceil(this.notificationsResult.totalCount / this.pageSize);
        this.notificationsList = this.notificationsList.concat(this.notificationsResult.pageData);
        // this.notificationsResult.unSeenNotificationsCount = 0;
      }, err => {
        this.notifLoading = false;
        console.error(err);
      });
  }
}
